import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconSuccess = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <path d="M5.27783 9.50022L8.09265 12.1391L13.7223 6.86133" stroke="#4EC6B7" stroke-width="1.5" />
      <circle cx="9.5" cy="9.5" r="8.75" stroke="#4EC6B7" stroke-width="1.5" />
    </svg>
  )
}

export default IconSuccess